'use client';

import { Button } from '@/components/ui/button';
import { FileIcon, XIcon } from 'lucide-react';

interface FileRowProps {
  readonly name: string;
  readonly href?: string;
  readonly onRemove?: () => void;
}

export function FileRow({ name, href, onRemove }: FileRowProps) {
  return (
    <li className='flex items-center justify-between gap-3 rounded-lg border bg-card px-4 py-3 text-sm shadow-sm'>
      <div className='flex min-w-0 items-center gap-3'>
        <div className='flex size-8 shrink-0 items-center justify-center rounded-md bg-primary/10'>
          <FileIcon className='size-4 text-primary' />
        </div>
        {href ? (
          <a
            href={href}
            target='_blank'
            rel='noopener noreferrer'
            className='truncate font-medium hover:underline'
          >
            {name}
          </a>
        ) : (
          <span className='truncate font-medium'>{name}</span>
        )}
      </div>
      {onRemove && (
        <Button
          type='button'
          variant='ghost'
          size='icon'
          onClick={onRemove}
          className='size-8 shrink-0 text-muted-foreground hover:text-destructive print:hidden'
        >
          <XIcon className='size-4' />
          <span className='sr-only'>Ta bort fil</span>
        </Button>
      )}
    </li>
  );
}
